import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

const renderMd = (md) => {
  const out = [];
  let list = null;
  const flush = (k) => { if (list) { out.push(<ul key={`ul-${k}`} className="list-disc pl-6 space-y-1.5 my-3">{list}</ul>); list = null; } };
  const inline = (s) =>
    s.split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|`[^`]+`)/g).map((p, i) => {
      if (p.startsWith("**")) return <strong key={i}>{p.slice(2, -2)}</strong>;
      if (p.startsWith("`")) return <code key={i} className="bg-gray-100 rounded px-1 text-[13px]">{p.slice(1, -1)}</code>;
      const m = p.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
      if (m) return <a key={i} href={m[2]} target="_blank" rel="noreferrer" className="text-blue-600 underline">{m[1]}</a>;
      return p;
    });
  md.split("\n").forEach((raw, i) => {
    const line = raw.trimEnd();
    if (line.startsWith("- ")) { (list = list || []).push(<li key={i}>{inline(line.slice(2))}</li>); return; }
    flush(i);
    if (!line.trim()) return;
    if (line.startsWith("# ")) out.push(<h1 key={i} className="font-heading text-3xl sm:text-4xl font-bold text-gray-900 mb-2">{inline(line.slice(2))}</h1>);
    else if (line.startsWith("## ")) out.push(<h2 key={i} className="font-heading text-lg font-bold text-gray-900 mt-8 mb-2">{inline(line.slice(3))}</h2>);
    else if (line.startsWith("_") && line.endsWith("_")) out.push(<p key={i} className="text-sm text-gray-400 italic mb-6">{line.slice(1, -1)}</p>);
    else out.push(<p key={i} className="text-[15px] text-gray-700 leading-relaxed my-2">{inline(line)}</p>);
  });
  flush("end");
  return out;
};

export default function LegalPage({ docKey }) {
  const params = useParams();
  const key = docKey || params.key;
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setDoc(null); setErr(false);
    api.get(`/legal/${key}`).then((r) => setDoc(r.data)).catch(() => setErr(true));
    window.scrollTo(0, 0);
  }, [key]);

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${key}`}>
      <header className="border-b border-gray-100 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-heading font-bold text-gray-900" data-testid="legal-home-link">Agentic Inbox</Link>
        <div className="flex gap-4 text-sm text-gray-500">
          <Link to="/privacy-policy" data-testid="legal-nav-privacy" className={key === "privacy" ? "text-gray-900 font-semibold" : "hover:text-gray-900"}>Privacy Policy</Link>
          <Link to="/terms" data-testid="legal-nav-terms" className={key === "terms" ? "text-gray-900 font-semibold" : "hover:text-gray-900"}>Terms &amp; Conditions</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12" data-testid="legal-content">
        {err && <p className="text-gray-500">This document is unavailable right now.</p>}
        {!doc && !err && <p className="text-gray-400">Loading…</p>}
        {doc && renderMd(doc.content)}
        {doc && <p className="text-xs text-gray-400 mt-12 border-t border-gray-100 pt-4" data-testid="legal-updated-at">Last updated: {new Date(doc.updated_at).toLocaleDateString([], { year: "numeric", month: "long", day: "numeric" })}</p>}
      </main>
    </div>
  );
}
